// extracted by mini-css-extract-plugin
export var infoItem = "_s9-2";
export var title = "_s9-0";
export var value = "_s9-1";